import {ArrowDir} from '@singularit/kurz-components'

// TODO rename file
export const calcArrowDir = (val: number): ArrowDir => {
  if (val < 0) return ArrowDir.DOWN
  else if (val > 0) return ArrowDir.UP
  else return ArrowDir.RIGHT
}
